import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Card, Icon } from '@node-space/ui-components'
import { formatAmount } from '../utils'

export interface RewardsBalanceCardProps {
  currency: string
  balance: string
  allTimeEarnings: string
}

export const RewardsBalanceCard = ({
  currency,
  balance,
  allTimeEarnings,
}: RewardsBalanceCardProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full>
      <Box flexCol gapY={8} paddingY={8} className="md:min-w-[282px]">
        <p className="text-body-regular-small text-foreground-prominent">
          {t('rewards.totalAllocatedBalance')}
        </p>

        <Box flex align="center" gap={8}>
          <Avatar name={currency} />
          <p className="text-h1 text-foreground-prominent">{formatAmount(Number(balance))}</p>
        </Box>

        <Box flex align="center" gap={8} className="text-foreground-prominent">
          <Icon name="SketchLogo" size="small" />
          <p className="text-body-strong text-foreground-subdued">
            {t('rewards.allTimeEarnings', { currency, amount: allTimeEarnings })}
          </p>
        </Box>
      </Box>
    </Card>
  )
}
